import { render, staticRenderFns } from "./HardwareShopList.vue?vue&type=template&id=475edd54&scoped=true&"
import script from "./HardwareShopList.vue?vue&type=script&lang=js&"
export * from "./HardwareShopList.vue?vue&type=script&lang=js&"
import style0 from "./HardwareShopList.vue?vue&type=style&index=0&id=475edd54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475edd54",
  null
  
)

/* custom blocks */
import block0 from "./HardwareShopList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports